import { createFileRoute } from '@tanstack/react-router'
import { requireRoles } from '@/lib/middleware'
import { MyIncidents } from '@/features/participant/incidents'

export const Route = createFileRoute(
  '/_authenticated/_organization/my-incidents/'
)({
  beforeLoad: async () => requireRoles(['client', 'primary_contact']),
  component: MyIncidents,
})
